export enum ContentTags {
  CONFIGURATION = "configuration",
  DEVICE = "device",
  GLOBAL = "global",
  LOGS = "logs",
  SELF_SUPPORTED = "self-supported",
  SPECIFIC = "specific",
}
